import styled from 'styled-components'
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton'

export const StyledRadioGroup = styled.fieldset`
  all: unset;

  & > div {
    display: flex;
  }

  ul {
    padding: 0;
    list-style: none;
    margin: 0 12px 0 0;
  }

  section {
    width: 250px;
    padding-right: 12px;
  }
`

export const StyledEditionFormFragment = styled.div`
  .textfield-helptext {
    word-break: break-all;
  }
`

export const StyledIconButton = styled(IconButton)`
  padding 3px;
` as React.ComponentType<IconButtonProps>
